module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("TWO")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("H")])])])]), _vm._v("awke Morran had no intention of dying. Not tonight anyway. He had payback to deliver and he wasn’t heading to the great beyond until he did so. If he hadn’t been gagged, he would have told his captors as much, but Jefferson hadn’t taken chances. Not only was Hawke gagged and trussed, he was blindfolded. Unfortunately for Jefferson, he hadn’t killed Hawke when he’d had the chance. It was a mistake he’d soon regret.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Hawke had managed to knock both men off their feet, but the rustle of movement and huff of their breathing told him they’d soon be back up. He stood still, waiting, knowing he might have only one chance to bring them down for good.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("If he failed, he’d be buried alive.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He didn’t plan to fail.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Rage fueled him, muting the pain that sliced through his skull, warming muscles already demanding a fight. Jefferson’s overweight buddy attacked from the left, his wheezing breath speaking of too many cigarettes and too little exercise. Hawke turned toward him, ducking low and then coming up hard, slamming his head into the man’s gut and hearing with satisfaction the crack of a rib.")])])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Agony pierced his skull, the hit he’d taken earlier allowing him no time to celebrate his victory. Nor did Jefferson allow time for Hawke to regain his balance. He came fast and quiet, but not quietly enough. Hawke spun on the balls of his feet, slashing Jefferson’s knee with his foot. The pop and scream of anguish that followed did little to satisfy Hawke’s rage. He wanted more. He wanted his hands free, wanted to wrap them around Jefferson’s neck until the man confessed every detail of the plan to set him up.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Watch out!” A feminine voice cut through the haze of Hawke’s pain and fury, the sound so surprising he swung toward it. It was a bad move. He knew it immediately. Years of survival in a world where one wrong move meant death had taught him how swift and final the consequences of such mistakes could be.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He pivoted back toward the attack he knew was coming, the world tilting, the pain in his skull breaking into shooting flames that seared his brain. Something flew by his face, a crack and thud following so quickly he wasn’t sure he’d really heard them. Then silence. Thick. Heavy. Filled with a million possibilities. None of them good.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Footsteps rustled through grass, slow, cautious. Not the full-on attack Hawke expected. The air around him shifted, the scent of apples and cinnamon wafting toward him, mellow, sweet and completely unexpected.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He tensed, waited.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Fingers brushed his arm. Gentle, trembling, hesitant. “Are you okay?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He nodded, gritting his teeth at the stars shooting through his head.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('span', [_vm._v("“Okay. Wait here. I’m going to find a phone. Call the ")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("police.” The voice was breathless and shaky, the fingers that brushed against his forearm starting to slip away.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('span', [_vm._v("He managed to grab them, holding tight when she would have pulled away. Whoever she was, whatever she’d come here for, she’d gotten herself into a mess of trouble. Leaving and calling the police wouldn’t change that.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('span', [_vm._v("“You want me to untie you first.” It wasn’t a question, but Hawke nodded anyway. He’d been determined to escape before. Now, he was desperate to. If he didn’t, he wouldn’t be the only one lying at the bottom of another man’s grave.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('span', [_vm._v("The woman’s fingers danced over the tape that bound his wrists, pulling gently as if she were afraid of hurting him.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('span', [_vm._v("Come on, lady. Hurry up. He wanted to shout the words, convey by his tone just how desperate their situation was, but the tape over his mouth kept him mute, and he was forced to stand silent while she worked. Sweat beaded his brow, the dizzying pain in his head making him nauseous, but he wouldn’t give in to it. There was too much at stake.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('span', [_vm._v("Finally the tape loosened and he twisted his wrists, breaking through what was left of his bonds. The blindfold was next. Then the tape that covered his mouth.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('span', [_vm._v("He swung around, caught sight of the woman who’d freed him.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('span', [_vm._v("Soft. That was his first impression. Soft hair, soft full lips and soft eyes that widened as she took in his appearance. It was a reaction Hawke was used to and he ignored it, turning to search for his enemies. They were both on the ground. The heavier man lay in a heap, quiet groans issuing from between puffy lips. Jefferson was ")])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("sprawled a few feet away from his buddy, a gun an arm’s length away and bits of a clay pot scattered around him. “Looks like it’s time to add flower pots to the list of deadly weapons.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('span', [_vm._v("“Deadly? I hope I didn’t kill him.” The woman’s voice was as soft as her appearance, her hair swinging forward as she leaned toward Jefferson.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('span', [_vm._v("Hawke put a hand on her arm, stopping her before she could check for his pulse. “He’s not dead.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('span', [_vm._v("But Hawke was tempted to finish him off. He might have if the woman hadn’t been watching him with wide, frightened eyes, or if his own moral code hadn’t altered drastically in the past year. An eye for an eye had once been his motto. Lately, that had changed. He hadn’t quite figured out what it had changed to, but killing Jefferson was no longer an option.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('span', [_vm._v("Somewhere in the distance, a siren blared to life, the sound spurring Hawke’s sluggish brain to action. “We need to get out of here.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('span', [_vm._v("He moved forward, grabbed the gun that lay by Jefferson, checked the safety. He could feel the woman’s gaze, her fear and coiled tension.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('span', [_vm._v("“What are you doing?” she whispered, her voice shaky.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('span', [_vm._v("“Making sure we have protection.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('span', [_vm._v("“Protection? From what? Neither of them look like they’re getting up anytime soon.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('span', [_vm._v("“It’s not them I’m worried about.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('span', [_vm._v("“Then who?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('span', [_vm._v("“I’ll explain everything later. Right now, we need to get out of here.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('span', [_vm._v("“You’re right. We need to call for help.” She started away, moving toward the side of the building.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('span', [_vm._v("Hawke lunged forward, grabbing her arm. “Not yet.”")])])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She tried to pull back, but he didn’t release his hold, just tugged her toward the SUV.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Let me go.” The panic in her voice might have made him hesitate if he weren’t so sure hesitation would mean death.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I can’t.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Sure you can.” She jerked against his hold, her face a pale oval in the moonlight. “Just open your fingers and let me walk away.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“If you leave here without me there’s a good possibility you won’t live to see tomorrow. I don’t want that on my conscience.” He didn’t give her a chance to argue, just pulled open the door of the SUV and glanced inside.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("As he’d expected the keys were in the ignition. Another mistake Jefferson was going to regret making. “Get in.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I’m not—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I said, "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("get in.”")])]), _vm._v(" He half lifted, half shoved her into the car.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Hey! What are you doing?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Scoot over.” Hawke ignored the woman’s protest, sliding into the car and giving her no choice but to move into the passenger seat.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('span', [_vm._v("She scrambled for the door, and he snagged her shirt, holding her in place with one hand and firing up the engine with the other. Even with the windows closed, the sound of sirens was audible and growing louder. Hawke pressed down on the gas, gunning the engine and sending the SUV shooting up the slope of a hill toward a distant road. If he was lucky, he’d make it there and be able to hide the SUV in heavy Friday-night traffic. Unfortunately, he’d never had much luck. ")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("Maybe, though, for the sake of the woman who’d saved him, God might grant him his fair share tonight.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('span', [_vm._v("“Stop the car! Let me out!” The passenger door flew open, and Hawke just managed to grab the woman’s hand before she could jump from the vehicle.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('span', [_vm._v("“Do you want to get yourself killed?” His roar froze her in place. Or maybe it was the sight of the ground speeding by that kept her from pulling from his hold and leaping out.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('span', [_vm._v("Hawke slowed the SUV, afraid his seatbelt-less passenger would fly out on the next bounce. “Close the door.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('span', [_vm._v("“I’d rather you stop the car so I can get out.” Her voice shook and her hand trembled violently as she tugged against his hold, but there was no mistaking her determination.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('span', [_vm._v("She didn’t know him, didn’t know the situation and probably assumed the worst. If he’d had time to explain, he would have, but he didn’t. Not with death following so close behind them.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('span', [_vm._v("He released her hand, pulled the gun from the waistband of his jeans and pointed it toward the already terrified woman, ruthlessly shoving aside every shred of compassion he felt for her. “I said, close the door.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('span', [_vm._v("She hesitated and he wondered if she’d take a chance and jump. Finally, she reached for the handle and pulled the door closed, her body tense and trembling.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('span', [_vm._v("“Where are you taking me?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('span', [_vm._v("“Somewhere safe.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('span', [_vm._v("“Where exactly is that?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('span', [_vm._v("“I’ll let you know when I figure it out.” Hawke winced as the SUV bumped over a curb, its tires sliding onto smooth pavement. Traffic was lighter then he’d ")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("expected, and he merged onto the road, picking up speed and hoping that would be enough to discourage his passenger from trying to jump out again. Being distracted didn’t figure into his escape plan. Then again, escaping with a woman who looked like she belonged in a cozy home with a couple of kids playing at her feet wasn’t part of his plan, either.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('span', [_vm._v("So he’d have to make a new plan. Fast.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('span', [_vm._v("But first, he needed to get to a safe place.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('span', [_vm._v("Miranda fisted her hand around her purse and tried to control her breathing. If she hyperventilated and passed out there’d be no chance of escape. The man beside her still held the gun pointed in her direction. Though his gaze was fixed on the road, Miranda was sure he was aware of every move she made. A few minutes ago he’d seemed a helpless victim who needed saving. Now she wasn’t so sure.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('span', [_vm._v("Something flashed in the periphery of her vision, and she glanced in the side mirror, catching sight of blue and white lights in the distance. Hope made her heart leap and her pulse race.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('span', [_vm._v("Please let them be coming for us.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('span', [_vm._v("But even as she mumbled the prayer, her dark-haired kidnapper took the beltway ramp, speeding into traffic with barely a glance at oncoming vehicles. Miranda gasped, releasing her purse so that she could hold on to the seat. The lights had disappeared from view, but the car’s speed and swift lane changes should attract more police attention.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('span', [_vm._v("If it didn’t get Miranda and her kidnapper killed first.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('span', [_vm._v("As if he sensed her thoughts, the man eased up on the gas and pulled into the slow lane, dashing Miranda’s ")])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("hope of rescue. Tense with worry, sick with dread, she prayed desperately for some way out, her gaze scanning the cars that passed, her mind scrambling for a plan. Any plan.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('span', [_vm._v("“If you let me out here, I won’t press charges.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('span', [_vm._v("“Charges?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('span', [_vm._v("“Kidnapping is a serious crime.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('span', [_vm._v("“Kidnapping? Is that what you call this?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('span', [_vm._v("“What would you call it?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('span', [_vm._v("“Returning a favor. You saved my life. Now I’m doing the same for you.” His voice was harsh, an exotic accent adding depth and richness to the words, but doing nothing to soften the tone.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('span', [_vm._v("“It’s hard to believe that’s what you’re doing when you’re pointing a gun at me.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('span', [_vm._v("“Sorry. It seemed the only way to keep you from doing something we’d both regret.” He tucked the gun back into the waistband of his jeans, his movements economical and practiced, as if he’d done the same a thousand times before.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('span', [_vm._v("And somehow, looking at his chiseled face and the scar that bisected it from cheekbone to chin, Miranda had a feeling he had. She slid closer to the door, wishing they were in bumper-to-bumper traffic or that she dared jump out of a car traveling sixty miles an hour. But they weren’t, she didn’t. She was reduced to sitting terrified as she was driven farther and farther from home.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('span', [_vm._v("She eyed the man, the door, the traffic speeding by. Maybe she could attract someone’s attention with a gesture or an expression. Maybe—")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('span', [_vm._v("“Whatever you’re thinking, forget it.” He wasn’t even looking her way, yet seemed to sense her intentions.")])])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She stiffened, turning to face him again. “I’m not thinking anything.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Sure you are. You’re thinking about opening the door and jumping for it. Or maybe attracting someone’s attention.” He shrugged. “It’s what I’d do if I were in your position.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“And if I were in "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("your")])]), _vm._v(" position, I’d stop the car and let my prisoner out.” She tried to put confidence in her voice, tried to sound less scared than she felt.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“You’re not a prisoner.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Then what am I?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“The newest member of the witness protection program.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Miranda blinked, not sure she’d heard right. “Are you with the FBI?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He hesitated and Miranda had the feeling he was trying to decide how much of the truth to tell her. When he finally answered, his tone was much more gentle than it had been before. “No, but I plan to be just as effective in keeping you safe.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I don’t need you to keep me safe. I need you to let me go.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Then it would have been better if you’d walked away and left me to deal with Jefferson on my own.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“He was trying to kill you.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“And now he’s going to try to kill us both.” His tone was grim, his jaw tight, and Miranda had no doubt he believed what he was saying.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She just wasn’t sure she did. “Why?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Because I’m a threat and because you were in the wrong place at the wrong time and were foolish enough to let him know it.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“What else was I suppose to do? Let him kill you?”")])])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Let whatever was to happen, happen.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I couldn’t.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Then maybe you’ll understand why I can’t let you go.” His tone was softer than Miranda would have expected from such a hard-looking man and she studied his profile, wishing she could read more in his face.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Who are you?” The question popped out, though Miranda wasn’t sure what answer she hoped for—a name, an occupation, some clue as to who she was dealing with.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Hawke Morran.” He answered the question without actually answering it. The name doing nothing to explain who Hawke was or why Liam had been trying to kill him.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Who are you to Liam?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Liam? You know Jefferson?” The gentleness was gone, replaced by a harshness that made Miranda cringe.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Everyone in Essex knows him.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I’m not interested in everyone. I’m interested in you. You say you know him. Does "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("he")])]), _vm._v(" know "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("you?")])]), _vm._v(" Your name? Where you live?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Did he? Miranda was sure he knew her name, and there was no doubt he knew where she worked, he visited the bakery several times a week. It would be easy enough to get her address. “Probably.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Hawke muttered something in a language Miranda didn’t recognize, the words unintelligible, the frustration behind them obvious.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("Her own frustration rose, joining the fear that pounded frantically through her blood. She’d done what she thought was right. Now, she’d pay for it. That seemed to be a pattern in her life. “I own a business in ")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("Essex. Lots of people know me. Liam just happens to be one of them.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("“He also just happens to be a murderer.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("Miranda didn’t need the reminder. She’d seen Liam in action; watched him pull a gun on a bound and blindfolded man, had seen the cold determination in his eyes as he’d caught sight of her. She had known then that she was seconds from death. “We need to go to the police and tell them what happened before Liam hurts someone else.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("“No.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("“What do you mean, no?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("“Exactly what I said. I’ve got a phony criminal record. The police won’t believe anything I have to say. You’re with me. It stands to reason they won’t believe you, either.” He glanced her way, his gaze searing into hers before he turned his attention back to the road.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("“Why—”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("“We’ll discuss it all later.” His tone was curt and dismissive, the kind that brooked no argument.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("And Miranda didn’t want to argue. She wanted to let things play out the way they would. Just as she had so many times before. With her sister. Her mother. Her father. Boyfriends. It always seemed so much easier to go with the flow than to fight against the tide. This time, though, the tide was dragging her out into dangerous waters and she had a feeling that if she didn’t fight it she’d be pulled under. “Later isn’t good enough. I want answers now.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("He shrugged, but didn’t speak as he steered the SUV onto an off-ramp.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("The neighborhood he drove through was battered, the houses 1970s cookie cutters, every street lined with ")])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("pickup trucks and scrap-metal cars. Miranda knew the area—a tough, crime-ridden neighborhood on the edge of D.C. When Hawke pulled into a driveway, she put her hand on the door, ready to yank it open and flee, but he grabbed her arm, his hand a steel band trapping her in place.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('span', [_vm._v("His breath fanned her cheek as he leaned close. “We’re getting out my side, walking around to the back of the house, getting a new ride and you’re not going to do anything foolish. Time isn’t on our side and I don’t want to waste any of it chasing after you. All right?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('span', [_vm._v("The memory of the gun he’d tucked into his waistband spurred Miranda to do as he said, her heart pounding a sickening beat as Hawke tugged her across the front seat and out the door.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('span', [_vm._v("The moon shone bright and yellow in the navy sky and the crisp air chilled Miranda’s clammy skin as Hawke hurried her around the side of a house.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('span', [_vm._v("An old garage stood at the back of the property and he punched numbers into a security pad on the door, then tugged Miranda to a dark sedan inside.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('span', [_vm._v("“Get in.” His words were gruff, his hand gentle as he pressed it against her shoulder, urging her to do as he’d commanded.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('span', [_vm._v("The car door slammed with a finality that stilled the breath in Miranda’s lungs. She shouldn’t be allowing this. Crime prevention experts said it all the time—never get in a car with your attacker. Never let him take you away from the scene.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('span', [_vm._v("And here she was, doing exactly that.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('span', [_vm._v("But Hawke wasn’t an attacker. He was a man who’d almost been killed. A man she’d saved. Now he claimed to be saving her. She wasn’t sure if she believed him. ")])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_vm._v("All she knew was that eventually there’d be a chance to escape. She could only pray that when it came, she’d know for sure whether or not she should take it.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53a9bc5e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/valleyofshadows_ch02.vue
// module id = 81
// module chunks = 0